import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function allowedValues(values: string[]): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control) {
      return null;
    }

    if (!values.includes(control.value)) {
      return { valueNotAllowed: true };
    }

    return null;
  };
}
